import clsx from "clsx";
import { List } from "@rigly/core";

// import { useAuthContext } from "../context/AuthContext";
// import { getMonthlyRevenue } from "../api/statistics";
import { Proxy, ProxyStats } from "../../types";

export type ProxyLine = {
  id: string;
  worker: Proxy;
  proxy: Proxy;
  isPassThrough: boolean;
}

export type ProxyData = {
  workerMachineName: string;
  inboundAddress: string;
  outboundAddress: string;
  hashratePassthrough: number;
  hashratePassthrough_300s: number;
  hashratePassthrough_24h: number;
  hashrateOrder: number;
  hashrateOrder_300s: number;
  hashrateOrder_24h: number;
  acceptedShares: number;
  acceptedShares_24h: number;
  rejectedShares: number;
  rejectedShares_24h: number;
};

export type ProxyTotals = {
  totalHashratePassthrough: number;
  totalHashrateOrder: number;
};

export type ProxiesDict = { 
  [id: string]: ProxyLine; 
}

const styleCaption = `text-sm text-zinc-700 dark:text-white font-semibold mb-[2px]`

export default function StratumProxiesList(
  { className, proxies }: 
  { 
    className?: string;
    proxies: ProxyStats[];
  }
) {
  // const { team } = useAuthContext();

  // const [revenue, setRevenue] = useState<any>(undefined);

  // const load = async () => {
  //   const res = getMonthlyRevenue(team.id);
  //   setRevenue(res);
  // };

  // useEffect(() => {
  //   if (team) {
  //     load();
  //   }
  // }, [team]);

  // const machines: ProxyLine[] = workerMachines ? Object.values(workerMachines) : []

  // if (machines) {
  //   machines.sort((a: ProxyLine, b: ProxyLine)=> {
  //     if (a.worker.host === b.worker.host) {
  //       if (a.worker.port === b.worker.port) return 0
  //       return a.worker.port > b.worker.port ? 1 : -1
  //     }
  //     return a.worker.host > b.worker.host ? 1 : -1
  //   })
  // }

  return (<>
    <div className={className}>
      <List 
        data={proxies || []}
        
        className={clsx(`w-full h-full min-h-[40vh]`)}
        spanClass="text-white text-xs"
        schema={[
          {
            label: 'Port',
            type: 'custom',
            key: (proxy: ProxyStats) => (
              <div className="text-zinc-600 dark:text-white text-xs text-center font-mono">
                {`proxy.rigly.io:${proxy.port}`}
              </div>
            )
          },
          {
            label: '12h Average Hashrate [TH/s]',
            type: 'custom',
            key: (proxy: ProxyStats) => (
              <div className="text-zinc-600 dark:text-white text-xs font-mono text-right">
                {((proxy.average_hashrate || 0))?.toFixed(2)}
              </div>
            )
          },
        ]}
      />
    </div>
  </>);
}
